import { formatCurrency } from '@ps/web-poker-utils';

import i18n from '../../i18n';
import type { Language, PokerGameTileAttribute, Prizes } from '../../types';
import { AttributeKey } from '../types';

const addPrizes = (prizes: Prizes['winners']) => prizes.reduce((a, b) => a + Number(b.amount), 0);

export interface SngAttributes {
  buyIn: number;
  rake: number;
  currency: number | string;
  maxPlayers: number;
  isPlayMoney: number;
  scalePM: number;
  prizes: Prizes[];
}
export default function sngAttrFormatter(
  { buyIn, rake, currency, maxPlayers, isPlayMoney, scalePM, prizes }: SngAttributes,
  language?: Language
): PokerGameTileAttribute[] {
  const i18nInstance = i18n(language);
  const winners = prizes && prizes[0] ? prizes[0].winners : [];
  const currencyAmount = maxPlayers * buyIn || addPrizes(winners);

  return [
    {
      name: i18nInstance('TXTWBCLI_Buy_In'),
      value: buyIn
        ? formatCurrency(buyIn + rake, currency, { separators: true, isPlayMoney, scalePM })
        : i18nInstance('TXTWBCLI_Freeroll'),
      key: AttributeKey.buyIn
    },
    {
      name: i18nInstance('TXTWBCLI_Players'),
      value: String(maxPlayers),
      key: AttributeKey.players
    },
    {
      name: i18nInstance('TXTWBCLI_Prize_Pool'),
      value: formatCurrency(currencyAmount, currency, {
        separators: true,
        shorten: true,
        isPlayMoney,
        scalePM
      }),
      key: AttributeKey.prizePool
    }
  ];
}
